/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EloshieldModule } from './EloshieldModule';
import {
    EloshieldModuleFromJSON,
    EloshieldModuleFromJSONTyped,
    EloshieldModuleToJSON,
    EloshieldModuleToJSONTyped,
} from './EloshieldModule';

/**
 * 
 * @export
 * @interface ActionTemplateUpdate
 */
export interface ActionTemplateUpdate {
    /**
     * 
     * @type {string}
     * @memberof ActionTemplateUpdate
     */
    label?: string | null;
    /**
     * 
     * @type {any}
     * @memberof ActionTemplateUpdate
     */
    nodes?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ActionTemplateUpdate
     */
    edges?: any | null;
    /**
     * 
     * @type {EloshieldModule}
     * @memberof ActionTemplateUpdate
     */
    eloshieldModule?: EloshieldModule | null;
}



/**
 * Check if a given object implements the ActionTemplateUpdate interface.
 */
export function instanceOfActionTemplateUpdate(value: object): value is ActionTemplateUpdate {
    return true;
}

export function ActionTemplateUpdateFromJSON(json: any): ActionTemplateUpdate {
    return ActionTemplateUpdateFromJSONTyped(json, false);
}

export function ActionTemplateUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionTemplateUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'nodes': json['nodes'] == null ? undefined : json['nodes'],
        'edges': json['edges'] == null ? undefined : json['edges'],
        'eloshieldModule': json['eloshieldModule'] == null ? undefined : EloshieldModuleFromJSON(json['eloshieldModule']),
    };
}

export function ActionTemplateUpdateToJSON(json: any): ActionTemplateUpdate {
    return ActionTemplateUpdateToJSONTyped(json, false);
}

export function ActionTemplateUpdateToJSONTyped(value?: ActionTemplateUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'nodes': value['nodes'],
        'edges': value['edges'],
        'eloshieldModule': EloshieldModuleToJSON(value['eloshieldModule']),
    };
}

